<template>
<div>
<!--  会议酒店管理  -->
  <a-modal
      :title="title"
      :visible="visible"
      :footer="null"
      @cancel="cancelBtn"
      width="850px"
  >
    <div class="ConferenceHotel">
      <div class="ConferenceHotel-form">
        <div style="margin-bottom: 20px">会议酒店信息：</div>
        <a-form-model
            ref="ruleForm"
            :model="form"
            :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }"
        >
          <a-row>
            <a-col :span="11">
              <a-form-model-item label="酒店名称">
                <a-input v-model="form.name" placeholder="请输入" style="width: 230px"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item label="酒店地址">
                <a-input v-model="form.address" placeholder="请输入" style="width: 230px"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item label="酒店联系人">
                <a-input v-model="form.contacts" placeholder="请输入" style="width: 230px"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="11">
              <a-form-model-item label="联系人电话">
                <a-input v-model="form.contactsTel" placeholder="请输入" style="width: 230px"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="2">
              <a-button type="primary" style="margin-top: 2px" @click="postHotelMeeting">保存</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div style="font-weight: normal">
        <a-button @click="openModel" type="primary" style="margin:20px 0">+ 新增会议室</a-button>
        <a-table :columns="columns" :data-source="data" :pagination="false">
          <span slot="serialNumber" slot-scope="text, record,index">
            {{index+1}}
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="editBtn(record)" style="margin-right: 10px">修改</a>
            <a-popconfirm
                title="是否确认删除?"
                ok-text="是"
                cancel-text="否"
                @confirm="selectSiteByConventionIdDel(record.id)"
            ><a href="#">删除</a></a-popconfirm>
          </span>
        </a-table>
<!--        <div class="pagination">-->
<!--          <a-pagination show-quick-jumper :default-current="current" :total="total" @change="onChange" />-->
<!--        </div>-->
      </div>
    </div>
  </a-modal>

  <a-modal
      :title="titleModel"
      :visible="visibleModel"
      @ok="okModelBtn"
      @cancel="cancelModelBtn"
      width="400px"
  >
    <a-form-model
        ref="ruleFormModel"
        :model="formModel"
        :rules="rulesModel"
        :label-col="{ span: 7 }" :wrapper-col="{ span: 14 }"
    >
      <a-row>
        <a-col :span="24">
          <a-form-model-item label="会议室地址" prop="meetAddress">
            <a-input v-model="formModel.meetAddress" placeholder="请输入" style="width: 230px"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="会场名称" prop="address">
            <a-input v-model="formModel.address" placeholder="请输入" style="width: 230px"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</div>
</template>

<script>
import {
  delSelectSiteByConventionId,
  getSelectHotel,
  getSelectSiteByConventionId,
  postSelectHotel,
  postSelectSiteByConventionId, putSelectSiteByConventionId
} from "@/service/hotelManageApi";

export default {
name: "HotelManagement",
  props:{
    visible:{
      type:Boolean,
    },
    title:{
      type:String
    },
    conventionCode:{
      type:String
    }
  },
  data(){
  return{
    form:{},
    // rules:{
    //   // region: [{ required: true, message: 'Please select Activity zone', trigger: 'change' }],
    // },
    columns:[
      {
        title: '序号',
        width:'10%',
        scopedSlots: { customRender: 'serialNumber' },
      },
      {
        title: '会议室地址',
        dataIndex: 'meetAddress',
        width:'30%',
        key: 'meetAddress',
      },
      {
        title: '会场名称',
        key: 'address',
        width:'20%',
        dataIndex: 'address',
      },
      {
        title: '操作',
        key: 'action',
        width:'10%',
        scopedSlots: { customRender: 'action' },
      },
    ],
    data:[],
    total:0,
    current:1,
    visibleModel:false,
    formModel:{
      meetAddress:'',
      address:'',
    },
    rulesModel:{
      meetAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
      address: [{ required: true, message: '请输入', trigger: 'blur' }],
    },
    titleModel:'',
  }
  },
  created() {
  this.getHotelMeeting();
  this.selectSiteByConventionId();
  },
  methods:{
    // 获取本次会议会议酒店并赋值
    async getHotelMeeting() {
      const res = await getSelectHotel(this.conventionCode)
      if(res.code === 200){
        this.form = res.data ? res.data:{};
        this.form.conventionCode = this.conventionCode;
      }
    },
    //修改会议酒店信息
    async postHotelMeeting() {
      if(this.form.name || this.form.address || this.form.contactsTel || this.form.contacts){
        const phoneRegex = /^1[3-9]\d{9}$/;
        if(!phoneRegex.test(this.form.contactsTel)){
          this.$message.warning('手机号格式有误！')
          return
        }

        const res = await postSelectHotel(this.form)
        if (res.code === 200) {
          this.$message.success("保存成功！")
          await this.getHotelMeeting();
        }else {
          this.$message.warning(res.message)
        }
      }else {
        this.$message.warning('请先输入内容!')
      }
    },


    // 获取会场会议室列表
    async selectSiteByConventionId() {
      const res = await getSelectSiteByConventionId(this.conventionCode)
      if(res.code === 200){
        this.data = res.data;
      }else {
        this.$message.warning(res.message)
      }
    },

    // 新增会场会议室列表
    async selectSiteByConventionIdPost(data) {
      const res = await postSelectSiteByConventionId(data)
      if(res.code === 200){
        this.$message.success("新增成功！");
        await this.selectSiteByConventionId();
        this.cancelModelBtn();
      }else {
        this.$message.warning(res.message)
      }
    },

    // 修改会场会议室列表
    async selectSiteByConventionIdPut(data) {
      const res = await putSelectSiteByConventionId(data)
      if(res.code === 200){
        this.$message.success("修改成功！");
        await this.selectSiteByConventionId();
        this.cancelModelBtn();
      }else {
        this.$message.warning(res.message)
      }
    },


    // 删除会场会议室列表
    async selectSiteByConventionIdDel(id) {
      let data = {
        id:id
      }
      const res = await delSelectSiteByConventionId(data)
      if(res.code === 200){
        this.$message.success("删除成功！");
        await this.selectSiteByConventionId();
      }else {
        this.$message.warning(res.message)
      }
    },


    cancelBtn(){
      let flag = false;
      this.$emit("closeMain", flag); //子组件向父组件传值(开关)
    },
    onChange(page,pageSize){
      this.current = page;
    },
    editBtn(row){
      this.titleModel = '修改';
      this.formModel = {
        id:row.id,
        meetAddress:row.meetAddress,
        address:row.address,
      };
      this.visibleModel = true;
    },
    cancelModelBtn(){
      this.visibleModel = false;
      this.formModel = {
        meetAddress:'',
        address:'',
      };
      this.$refs.ruleFormModel.resetFields();
    },
    okModelBtn(){
      this.$refs.ruleFormModel.validate(valid => {
        if (valid) {
          this.formModel.conventionCode = this.conventionCode;
          if(this.titleModel === '新增'){
            this.selectSiteByConventionIdPost(this.formModel);
          }else if(this.titleModel === '修改'){
            this.selectSiteByConventionIdPut(this.formModel);
          }

        } else {
          return false;
        }
      });
    },
    openModel(){
      if(this.form.name){
        this.titleModel = '新增';
        this.visibleModel = true;
      }else {
        this.$message.warning("请先设置酒店名称！")
      }

    },
  }
}
</script>

<style scoped lang="scss">
 .ConferenceHotel{
   font-weight: bold;
   color: #333333;
   min-height: 500px;
 }
 .ConferenceHotel-form{
   margin-bottom: 20px;
   border-bottom: 1px solid #e0e0e0;
 }
 .pagination{
   width: 100%;
   display: flex;
   justify-content: right;
   margin-top: 10px;
 }
</style>
